export default __webpack_public_path__ + "static/media/logo-white.ba440fe7.png";